// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import spfction from './spfction'
import ElementUI from 'element-ui'
import starpostUI from 'starpost-ui'
import axios from 'axios'
import GlobalJs from '../static/js/globalParams'
import Auth from '../static/js/auth'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/iconfont/iconfont.css'
import '@/assets/scss/public.scss'
import store from './store'
import request1 from '@/util/request1'
import { getToken, windowOpen1 } from '@/util/auth'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$request1 = request1
Vue.prototype.$getToken = getToken
Vue.prototype.$windowOpen1 = windowOpen1  // 自定义打开窗口

Vue.use(ElementUI)
Vue.use(starpostUI)
Vue.use(spfction)

/* eslint-disable no-new */
let vm = new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})

export default vm



// WEBPACK FOOTER //
// ./src/main.js